import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Context } from '../../Providers/Blade';
import MenuItem from '../MenuItem';

import { Login, Menu, MenuButton, Play } from './styles';

const navBreakpoint = 960;

export const MobileNav = styled(({ className, loginLink, loginText }) => {
  const { setState } = useContext(Context);

  // We force the blade menu to be closed when we go from mobile -> desktop
  let mediaQuery;
  const matchMedia = (breakpoint = mediaQuery) => {
    if (!breakpoint.matches) {
      setState(false);
    }
  };
  useEffect(() => {
    if (typeof window !== 'undefined') {
      mediaQuery = window.matchMedia(`(max-width: ${navBreakpoint}px)`);
      mediaQuery.addListener(matchMedia);
      matchMedia();
    }
    return () => {
      mediaQuery.removeListener(matchMedia);
    };
  }, []);

  return (
    <div className={className}>
      <Login
        to={loginLink.url}
        ariaLabel={loginLink.ariaLabelLogin}
        queryString={loginLink.queryStringLogin}
      >
        {loginText}
      </Login>
      <MenuButton onClick={() => setState(true)} />
    </div>
  );
})`
  && {
    @media (min-width: ${navBreakpoint + 1}px) {
      display: none;
    }
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }
`;

MobileNav.propTypes = {
  loginLink: PropTypes.string.isRequired,
  loginText: PropTypes.string.isRequired,
};

export const DesktopNav = styled(
  ({
    className,
    menu,
    openSections,
    onClick,
    loginLink,
    loginText,
    playLink,
    playText,
    resetState,
  }) => (
    <div className={className}>
      <Menu className="no-bullets">
        {menu &&
          menu.map((info, index) => {
            return (
              <li key={`mobile-menu-item-${index.toString()}`}>
                <MenuItem
                  data={info}
                  isOpen={!!openSections[info.text]}
                  label={info.text}
                  onClick={onClick}
                  resetState={resetState}
                />
              </li>
            );
          })}
      </Menu>
      <Login
        to={loginLink.url}
        ariaLabel={loginLink.ariaLabelLogin}
        queryString={loginLink.queryStringLogin}
      >
        {loginText}
      </Login>
      <Play
        to={playLink.url}
        ariaLabel={playLink.ariaLabelPlay}
        queryString={playLink.queryStringPlay}
        className="solid-on-light-bg"
      >
        {playText}
      </Play>
    </div>
  )
)`
  && {
    width: 100%;
    display: flex;
    @media (max-width: ${navBreakpoint}px) {
      display: none;
    }
  }
`;

DesktopNav.propTypes = {
  menu: PropTypes.arrayOf(PropTypes.shape()),
  openSections: PropTypes.shape(),
  onClick: PropTypes.func,
  loginLink: PropTypes.string,
  loginText: PropTypes.string,
  playLink: PropTypes.string,
  playText: PropTypes.string,
};
